import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import './filters.js';

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import Vuelidate from 'vuelidate';
import Swal from 'sweetalert2';
import smoothscroll from 'smoothscroll-polyfill';
import "./assets/styles/custom.css";

Vue.config.productionTip = false;
Vue.use(Vuelidate)
Vue.prototype.Swal  = Swal;
Vue.prototype.$http = axios;

const BASE_API_URL  = process.env.VUE_APP_BASE_API_URL;
axios.defaults.baseURL = BASE_API_URL;
axios.defaults.withCredentials = true;

//We want to smoothscroll to error, and this is not always natively supported
//@see https://www.npmjs.com/package/smoothscroll-polyfill
//If you wish to remove this, also comment out behavior:smooth in the scrollToError function
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
